import { render, staticRenderFns } from "./DepartmentUnitList.vue?vue&type=template&id=2425124e&"
import script from "./DepartmentUnitList.vue?vue&type=script&lang=js&"
export * from "./DepartmentUnitList.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentUnitList.vue?vue&type=style&index=0&id=2425124e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports